import { API } from "@/lib/auth";

// POST + read Server-Sent Events; calls onEvent for every JSON payload.
export async function streamAI(path, body, onEvent) {
  const headers = { "Content-Type": "application/json" };
  const t = localStorage.getItem("auth_token");
  const pin = localStorage.getItem("owner_pin");
  if (t) headers.Authorization = `Bearer ${t}`;
  if (pin) headers["X-Owner-Pin"] = pin;
  const r = await fetch(`${API}${path}`, { method: "POST", headers, body: JSON.stringify(body || {}) });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error(typeof j.detail === "string" ? j.detail : "AI request failed");
  }
  const reader = r.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    parts.forEach((p) => { const line = p.replace(/^data: /, ""); if (line) onEvent(JSON.parse(line)); });
  }
}

export const openAI = (detail) => window.dispatchEvent(new CustomEvent("ai-open", { detail }));
